var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        "close-on-press-escape": false,
        "close-on-click-modal": false,
        title: "拆分工单",
        visible: _vm.dialogVisible,
        top: "5vh",
        width: "85%",
        "before-close": _vm.handleClose
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogVisible = $event
        }
      }
    },
    [
      _c(
        "el-table",
        { attrs: { data: _vm.subTicketList } },
        [
          _c("el-table-column", {
            attrs: { label: "处理人", width: "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return _c("DealUserSearch", {
                    model: {
                      value: scope.row.dealUserId,
                      callback: function($$v) {
                        _vm.$set(scope.row, "dealUserId", $$v)
                      },
                      expression: "scope.row.dealUserId"
                    }
                  })
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "标题" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return _c("el-input", {
                    attrs: { placeholder: "工单标题" },
                    model: {
                      value: scope.row.orderTitle,
                      callback: function($$v) {
                        _vm.$set(scope.row, "orderTitle", $$v)
                      },
                      expression: "scope.row.orderTitle"
                    }
                  })
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "抄送", width: "250" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return _c("NoticeUserSearch", {
                    model: {
                      value: scope.row.ticketCcIds,
                      callback: function($$v) {
                        _vm.$set(scope.row, "ticketCcIds", $$v)
                      },
                      expression: "scope.row.ticketCcIds"
                    }
                  })
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "类型", width: "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return _c("TicketTypeCascader", {
                    attrs: { css: "width:100%" },
                    model: {
                      value: scope.row.orderType,
                      callback: function($$v) {
                        _vm.$set(scope.row, "orderType", $$v)
                      },
                      expression: "scope.row.orderType"
                    }
                  })
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "工时", width: "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return _c("el-input-number", {
                    attrs: { placeholder: "工时", precision: 1, min: 0 },
                    model: {
                      value: scope.row.workHour,
                      callback: function($$v) {
                        _vm.$set(scope.row, "workHour", $$v)
                      },
                      expression: "scope.row.workHour"
                    }
                  })
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            { staticStyle: { float: "left" }, on: { click: _vm.addRow } },
            [_vm._v("+")]
          ),
          _vm._v(" "),
          _c("el-button", { on: { click: _vm.handleClose } }, [_vm._v("取消")]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary", disabled: _vm.buttonDisabled },
              on: { click: _vm.doSubmit }
            },
            [_vm._v("提交")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-22e99483", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22e99483","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ticket/TicketSplitDialog.vue
// module id = 1006
// module chunks = 75